"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshAccountsMfaFormSubmitActionWatcher = exports.submitMfaResponse = exports.refreshAccountsWatcher = exports.refreshAccounts = exports.qcsInstitutionLoginActionActionWatcher = exports.deleteInstitutionLoginSuccessActionWatcher = exports.deleteInstitutionLoginActionWatcher = exports.updateInstitutionLoginActionWatcher = exports.getInstitutionLoginSuccessActionWatcher = exports.doInstitutionLoginAction = exports.preRefreshAccountsCheck = void 0;
const effects_1 = require("redux-saga/effects");
const immutable_1 = require("immutable");
const uuid_1 = require("uuid");
const luxon_1 = require("luxon");
const core_1 = require("companion-app-components/utils/core");
const core_2 = require("companion-app-components/flux/core");
const accounts_1 = require("companion-app-components/flux/accounts");
const prefActions = __importStar(require("companion-app-components/flux/preferences/actions"));
const root_ui_1 = require("companion-app-components/flux/root-ui");
const actionHelpers_1 = require("utils/actionHelpers");
const types_1 = require("data/institutionLogins/types");
const types_2 = require("data/AccountDiscovery/types");
const institutionsActions = __importStar(require("companion-app-components/flux/institutions/institutionsActions"));
const institutionsSelectors_1 = require("companion-app-components/flux/institutions/institutionsSelectors");
const transformers_1 = require("data/institutionLogins/transformers");
const RefreshTimeoutDialog_1 = require("components/Dialogs/RefreshTimeoutDialog");
const axiosFactory_1 = __importDefault(require("utils/axiosFactory"));
const actions = __importStar(require("./actions"));
const selectors_1 = require("./selectors");
const transformers = __importStar(require("./transformers"));
const log = (0, core_1.getLogger)('data/institutionLogins/sagas');
const qcsAxios = axiosFactory_1.default.get('qcs');
// =============================================================================
// Refresh Institution Logins
// =============================================================================
function* preRefreshAccountsCheck(loginsToRefresh, action) {
    // log.debug('Starting RefreshAccounts PreCheck');
    const credentialBlobsForRefreshingLogins = yield (0, effects_1.select)(selectors_1.getCredentialBlobsForRefreshingLogins);
    const credentialsForRefreshingLogins = yield (0, effects_1.select)(selectors_1.getCredentialsForRefreshingLogins);
    for (let i = 0; i < loginsToRefresh.length; ++i) {
        const login = loginsToRefresh[i];
        if (login.ewcLive) {
            log.debug('Found EWCLive account');
            if (credentialBlobsForRefreshingLogins.get(login.id) ||
                credentialsForRefreshingLogins.get(login.id)) {
                // already have credentials for this login so continue on to checking other logins
                // log.debug('Already have credentials, continuing to next login');
                continue; // eslint-disable-line
            }
            const userActionCancelled = yield (0, effects_1.select)(selectors_1.wasUserActionCancelled, login.id);
            if (userActionCancelled) {
                // already asked user for credentials, but they cancelled so we won't ask again
                // log.debug('User cancelled credentials, continuing to next login');
                continue; // eslint-disable-line
            }
            // ask user for credentials, then trigger refresh again
            const dialogData = root_ui_1.rootUiTypes.mkRootUiData({
                id: (0, uuid_1.v4)(),
                type: types_2.DIALOG_TYPE_ACCOUNTS_DISCOVERY,
                allowNesting: false,
                props: (0, immutable_1.Map)((0, types_2.mkAccountDiscoveryDialogProps)({
                    mode: 'PROVIDE-CREDENTIALS',
                    institutionLogin: login,
                    afterCloseAction: action,
                })),
            });
            log.log('Triggering Credential Request', dialogData);
            yield (0, effects_1.put)(root_ui_1.rootUiActions.createDialog(dialogData));
            yield (0, effects_1.put)(actions.refreshAccountsTriggeredCredentialsRequest(login.id));
            // terminate refesh (will trigger again after handling credentials for institution-login)
            return false;
        }
    }
    return true;
}
exports.preRefreshAccountsCheck = preRefreshAccountsCheck;
function* triggerGetAccountsAction() {
    // we now deal with deleted institution id's directly in the accounts reducer
    // removing them from REDUX, so no need to call QCS at this point
    // yield put(getAccounts());
}
// =================================================================================================
// Login Actions
// =================================================================================================
// a saga for utilizing the institution-logins/{id}/action endpoints
//
// {
//   id: accountId to impact
//   action: 'close' || 'disconnect' || 'make-manual'
// }
//
function* doInstitutionLoginAction({ payload, meta }) {
    var _a;
    const { qcsAction, id, params } = payload;
    const { resolve, reject } = meta;
    const requestUrl = `${(_a = (0, core_1.getEnvironmentConfig)()) === null || _a === void 0 ? void 0 : _a.services_url}/institution-logins/${id}/${qcsAction === null || qcsAction === void 0 ? void 0 : qcsAction.toLowerCase()}`;
    const requestBody = transformers.transformActionParamsToRequestData(qcsAction, params);
    try {
        const { data } = yield (0, effects_1.call)(qcsAxios.put, requestUrl, requestBody);
        const login = transformers.transformQcsInstitutionLoginToInstitutionLogin(data.resource);
        yield (0, effects_1.put)(actions.qcsInstitutionLoginActionResponse(login));
        // TODO: This could be done in a generalized utility method
        const { impactedResources } = data;
        if (impactedResources === null || impactedResources === void 0 ? void 0 : impactedResources.accounts) {
            const accounts = accounts_1.accountsTransformers.transformQcsAccountsToAccounts(impactedResources.accounts);
            yield (0, effects_1.put)(accounts_1.accountsActions.applyAccountsChanges(accounts));
        }
        yield (0, effects_1.call)(resolve);
    }
    catch (error) {
        log.error(`Error performing QCS account action ${qcsAction}`, error);
        yield (0, effects_1.put)(actions.qcsInstitutionLoginActionResponse(error));
        yield (0, effects_1.call)(reject, error);
    }
}
exports.doInstitutionLoginAction = doInstitutionLoginAction;
// =============================================================================
// Watchers
// =============================================================================
const mkResourceConfig = (successAction, failureAction) => core_2.resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'institution-login',
    resourceBaseUrl: '/institution-logins',
    getLastSyncDate: selectors_1.getLastSyncDate,
    transformResponseToResources: transformers.transformResponseToInstitutionLogins,
    transformResourceToRequestData: transformers.transformInstitutionLoginToRequestData,
    successAction,
    failureAction,
});
function* getInstitutionLoginsActionWatcher() {
    // using a vanilla saga pattern so we only process a single get request
    //   - takeEvery would process every request
    //   - takeLatest would cancel any current request and start request again
    while (true) {
        const action = yield (0, effects_1.take)(actions.getInstitutionLogins);
        const resourceConfig = mkResourceConfig(actions.getInstitutionLoginsSuccess, actions.getInstitutionLoginsFailure);
        yield (0, effects_1.call)((core_2.resourceSagaUtils.qcsSyncGetResources), resourceConfig, action);
    }
}
function* getInstitutionLoginSuccessActionWatcher() {
    const action = yield (0, effects_1.take)(actions.getInstitutionLoginsSuccess);
    const institutions = yield (0, effects_1.select)(institutionsSelectors_1.getInstitutionsById);
    const fetchInstitutionIds = action.payload.resources.reduce((institutionIds, login) => {
        if (login.institutionId && !institutions.has(login.institutionId)) {
            const channelType = login === null || login === void 0 ? void 0 : login.channel;
            institutionIds.add({ id: login.institutionId, channelType });
        }
        return institutionIds;
    }, new Set());
    const iterator = fetchInstitutionIds[Symbol.iterator]();
    for (let result = iterator.next(); !result.done; result = iterator.next()) {
        const { id, channelType } = result.value;
        yield (0, effects_1.put)(institutionsActions.getInstitution({ id }, { props: { channelType } }));
    }
}
exports.getInstitutionLoginSuccessActionWatcher = getInstitutionLoginSuccessActionWatcher;
function* updateInstitutionLoginActionWatcher() {
    const resourceConfig = mkResourceConfig(actions.updateInstitutionLoginSuccess, actions.updateInstitutionLoginFailure);
    yield (0, effects_1.takeEvery)(actions.updateInstitutionLogin, core_2.resourceSagaUtils.qcsSyncUpdateResource, resourceConfig);
}
exports.updateInstitutionLoginActionWatcher = updateInstitutionLoginActionWatcher;
function* deleteInstitutionLoginActionWatcher() {
    const resourceConfig = mkResourceConfig(actions.deleteInstitutionLoginSuccess, actions.deleteInstitutionLoginFailure);
    yield (0, effects_1.takeEvery)(actions.deleteInstitutionLogin, core_2.resourceSagaUtils.qcsSyncDeleteResource, resourceConfig);
}
exports.deleteInstitutionLoginActionWatcher = deleteInstitutionLoginActionWatcher;
function* deleteInstitutionLoginSuccessActionWatcher() {
    yield (0, effects_1.takeEvery)(actions.deleteInstitutionLoginSuccess, triggerGetAccountsAction);
}
exports.deleteInstitutionLoginSuccessActionWatcher = deleteInstitutionLoginSuccessActionWatcher;
function* qcsInstitutionLoginActionActionWatcher() {
    yield (0, effects_1.takeLatest)(actions.qcsInstitutionLoginAction, doInstitutionLoginAction);
}
exports.qcsInstitutionLoginActionActionWatcher = qcsInstitutionLoginActionActionWatcher;
// =================================================================================================
// Refresh Accounts
// =================================================================================================
// poll every 3 seconds up to a total of 3 minutes and 30 seconds (seconds are buffer over QCS timeouts)
const REFRESH_POLL_INTERVAL = 3;
const REFRESH_POLL_ATTEMPTS = 210 / REFRESH_POLL_INTERVAL;
function* refreshPoll(url, institutionLoginId, meta, loginsToRefreshTrackingData) {
    var _a;
    assert(url, 'polling url is invalid - that should never happen...');
    let response;
    let numTimesLeftToPoll = REFRESH_POLL_ATTEMPTS;
    while (numTimesLeftToPoll > 0) {
        try {
            response = yield (0, effects_1.call)(qcsAxios.get, url);
            log.log('Polling for refresh status', response.data);
            const refreshStatus = transformers.transformResponseToRefreshStatus(response.data);
            log.log('Status after transforming...', refreshStatus);
            // send refresh status
            yield (0, effects_1.put)(actions.refreshAccountsStatuses(refreshStatus));
            let userActionIsPending = yield (0, effects_1.select)(selectors_1.isUserActionPending);
            const { institutionLogins } = refreshStatus;
            for (let i = 0; i < institutionLogins.size; ++i) {
                const login = institutionLogins.get(i);
                if (login.status === 'ACTION_REQUIRED') {
                    const userActionAlreadyQueued = yield (0, effects_1.select)(selectors_1.hasUserActionBeenQueued, login.id);
                    log.log('Refresh login status has action required', login, userActionAlreadyQueued);
                    if (!userActionAlreadyQueued && login.aggregators && login.aggregators.size > 0) {
                        // todo: currently QCS only supports a single aggregator per login, will need to
                        // todo: fix when QCS supports multiple aggregators per login
                        const aggregator = login.aggregators.get(0);
                        // todo: this should be checking aggregator.aggStatus === 'MFA_CHALLENGE_READY_FOR_USER' but QCS isn't setting this
                        if (aggregator && aggregator.mfaChallenges) {
                            const mfaChallenge = (0, transformers_1.transformMfaResponseToMfaChallenge)(login.id, aggregator.mfaChallenges, login.submitUrl ? login.submitUrl : '');
                            const institutionLogin = yield (0, effects_1.select)(selectors_1.getInstitutionLoginForId, mfaChallenge.institutionLoginId);
                            const mfaChallengeDialogData = root_ui_1.rootUiTypes.mkRootUiData({
                                id: (0, uuid_1.v4)(),
                                type: types_2.DIALOG_TYPE_ACCOUNTS_DISCOVERY,
                                allowNesting: !userActionIsPending,
                                props: (0, immutable_1.Map)((0, types_2.mkAccountDiscoveryDialogProps)({
                                    mode: 'PROVIDE-MFA',
                                    institutionLogin,
                                    mfaChallenge,
                                })),
                            });
                            log.log('Triggering MFA', mfaChallenge);
                            yield (0, effects_1.put)(root_ui_1.rootUiActions.createDialog(mfaChallengeDialogData));
                            yield (0, effects_1.put)(actions.refreshAccountsTriggeredMfa(mfaChallenge.institutionLoginId));
                            userActionIsPending = true;
                        }
                    }
                }
                else if (!login.isProcessing && loginsToRefreshTrackingData.has(login.id)) {
                    const data = loginsToRefreshTrackingData.get(login.id);
                    loginsToRefreshTrackingData.delete(login.id);
                    if (login.status === 'OK') {
                        core_1.tracker.track(core_1.tracker.events.refreshSuccess, data);
                    }
                    else {
                        const aggregator = (_a = login.aggregators) === null || _a === void 0 ? void 0 : _a.get(0);
                        const trackingData = Object.assign(Object.assign({}, data), { error_code: aggregator === null || aggregator === void 0 ? void 0 : aggregator.aggStatus, agg_status_code: aggregator === null || aggregator === void 0 ? void 0 : aggregator.cpAggStatus, agg_status_detail: aggregator === null || aggregator === void 0 ? void 0 : aggregator.cpAggStatusDetail });
                        core_1.tracker.track(core_1.tracker.events.refreshError, trackingData);
                    }
                }
            }
            if (!userActionIsPending && !response.data.isProcessing) {
                yield (0, effects_1.put)(actions.refreshAccountsCompleted({ institutionLoginId, status: 'DONE_PROCESSING' }, meta));
                // server is done processing and we are not waiting for an MFA so stop polling
                // todo: can maybe optimize by not polling while waiting for MFA but need to restart once MFA is submitted
                break;
            }
            numTimesLeftToPoll -= 1;
            log.log(`Number of times left to poll is ${numTimesLeftToPoll} #refresh`);
            yield (0, effects_1.delay)(REFRESH_POLL_INTERVAL * 1000);
        }
        catch (error) {
            log.log('How did we get here...', error);
            yield (0, effects_1.put)(actions.refreshAccountsCompleted({ institutionLoginId, status: 'FAILED_WHEN_POLLING' }, meta));
            // trackRefreshErrors('FAILED_WHEN_POLLING', loginsToRefreshTrackingData);
            break;
        }
    }
    if (numTimesLeftToPoll === 0) {
        const idsRefreshingWithUserActionsPending = yield (0, effects_1.select)(selectors_1.getIdsRefreshingWithUserActionsPending);
        if (idsRefreshingWithUserActionsPending.size > 0) {
            yield (0, effects_1.put)(root_ui_1.rootUiActions.createDialog(root_ui_1.rootUiTypes.mkRootUiData({
                type: RefreshTimeoutDialog_1.DIALOG_TYPE,
                props: (0, immutable_1.Map)((0, RefreshTimeoutDialog_1.mkRefreshTimeoutDialogProps)({
                    dialogIdsToClose: idsRefreshingWithUserActionsPending.toList(),
                    confirmationDialogProps: (0, RefreshTimeoutDialog_1.mkConfirmationDialogProps)({
                        content: 'The server terminated the refresh operation due to length of time.',
                        confirmLabel: 'retry',
                        denyLabel: 'cancel',
                        confirmAction: actions.refreshAccounts(),
                    }),
                })),
            })));
        }
        yield (0, effects_1.put)(actions.refreshAccountsCompleted({ institutionLoginId, status: 'TIMEOUT_WHILE_PROCESSING' }, meta));
        // trackRefreshErrors('TIMEOUT_WHILE_PROCESSING', loginsToRefreshTrackingData);
    }
}
function* isRefreshCancelledForLogin(login) {
    return yield (0, effects_1.select)(selectors_1.wasUserActionCancelled, login.id);
}
function* refreshAccounts(action) {
    var _a, _b, _c, _d;
    const { payload: data, meta } = action;
    const institutionLoginId = data != null ? data.institutionLoginId : null;
    const loginsToRefresh = [];
    if (institutionLoginId) {
        const login = yield (0, effects_1.select)(selectors_1.getInstitutionLoginForId, data.institutionLoginId);
        if (login) {
            const refreshCancelledForLogin = yield* isRefreshCancelledForLogin(login);
            if (!refreshCancelledForLogin) {
                loginsToRefresh.push(login);
            }
        }
    }
    else {
        const loginsById = yield (0, effects_1.select)(selectors_1.getInstitutionLoginsById);
        const allLogins = loginsById.valueSeq().toArray();
        for (let i = 0; i < allLogins.length; ++i) {
            const login = allLogins[i];
            const refreshCancelledForLogin = yield* isRefreshCancelledForLogin(login);
            if (!refreshCancelledForLogin) {
                loginsToRefresh.push(login);
            }
        }
    }
    if (loginsToRefresh.length === 0) {
        yield (0, effects_1.put)(actions.refreshAccountsCompleted({ institutionLoginId, status: 'NO_ACCOUNTS_TO_REFRESH' }, meta));
        return;
    }
    // @ts-expect-error - Type 'SagaIterator' must have a '[Symbol.iterator]()' method that returns an iterator.ts(2488)
    const preCheckPassed = yield* preRefreshAccountsCheck(loginsToRefresh, action);
    if (!preCheckPassed) {
        yield (0, effects_1.put)(actions.refreshAccountsPrecheck());
        return;
    }
    // Set lastRefreshedAt in preferences under webApp group on each refresh triggered.
    const prefObj = {
        section: 'shared',
        group: 'dataset',
        preference: { webApp: { lastRefreshedAt: luxon_1.DateTime.utc().toISO() } },
    };
    yield (0, effects_1.put)(prefActions.setPreference(prefObj));
    const loginsToRefreshTrackingData = new Map();
    for (let i = 0; i < loginsToRefresh.length; i++) {
        const login = loginsToRefresh[i];
        const aggregator = yield (0, effects_1.select)(selectors_1.getTrackingAggregator, (_a = login.id) !== null && _a !== void 0 ? _a : '');
        const institution = login.institutionId ? yield (0, effects_1.select)(institutionsSelectors_1.getInstitution, login.institutionId) : null;
        const trackingData = {
            aggregator,
            // initiator
            institution_login_id: login.id,
            institution_id: login.institutionId,
            institution_name: (institution === null || institution === void 0 ? void 0 : institution.name) ? institution.name : 'unknown',
        };
        loginsToRefreshTrackingData.set(login.id, trackingData);
        core_1.tracker.track(core_1.tracker.events.refreshStart, trackingData);
    }
    // special case when refreshing a single institution login
    let requestUrl;
    if (loginsToRefresh.length === 1) {
        requestUrl = `${(_b = (0, core_1.getEnvironmentConfig)()) === null || _b === void 0 ? void 0 : _b.services_url}/institution-logins/${loginsToRefresh[0].id}/refresh`;
    }
    else {
        requestUrl = `${(_c = (0, core_1.getEnvironmentConfig)()) === null || _c === void 0 ? void 0 : _c.services_url}/institution-logins/refresh`;
    }
    const credentialsBlobsForRefreshingLogins = yield (0, effects_1.select)(selectors_1.getCredentialBlobsForRefreshingLogins);
    const credentialsForRefreshingLogins = yield (0, effects_1.select)(selectors_1.getCredentialsForRefreshingLogins);
    const requestBody = (0, transformers_1.transformRefreshingLoginsToRequestData)(loginsToRefresh, credentialsBlobsForRefreshingLogins, credentialsForRefreshingLogins);
    let pollingReference = '';
    try {
        const response = yield (0, effects_1.call)(qcsAxios.post, requestUrl, requestBody);
        log.log('Refresh accounts response is', response.data);
        pollingReference = response.data.pollingReference;
        log.log('pollingReference=', pollingReference);
    }
    catch (error) {
        log.log('Error refreshing accounts', error);
        yield (0, effects_1.put)(actions.refreshAccountsCompleted({ institutionLoginId, status: 'FAILED_WHEN_POLLING' }, meta));
        // trackRefreshErrors('FAILED_WHEN_POLLING', loginsToRefreshTrackingData);
        // if we failed to kickoff refresh, were done
        return;
    }
    // poll until refresh is ready or cancel action
    if (pollingReference && pollingReference.length && pollingReference.length > 0) {
        requestUrl = `${(_d = (0, core_1.getEnvironmentConfig)()) === null || _d === void 0 ? void 0 : _d.services_url}${pollingReference}`;
        // @ts-expect-error - Type 'SagaIterator' must have a '[Symbol.iterator]()' method that returns an iterator.ts(2488)
        yield* refreshPoll(requestUrl, institutionLoginId, meta, loginsToRefreshTrackingData);
    }
    else {
        yield (0, effects_1.put)(actions.refreshAccountsCompleted({ institutionLoginId, status: 'DONE_PROCESSING' }, meta));
        // trackRefreshErrors('DONE_PROCESSING', loginsToRefreshTrackingData);
    }
}
exports.refreshAccounts = refreshAccounts;
function* refreshAccountsWatcher() {
    // using a vanilla saga pattern so we only process a single get request
    //   - takeEvery would process every request
    //   - takeLatest would cancel any current request and start request again
    while (true) {
        const action = yield (0, effects_1.take)(actions.refreshAccounts);
        yield (0, effects_1.call)(refreshAccounts, action);
    }
}
exports.refreshAccountsWatcher = refreshAccountsWatcher;
function* submitMfaResponse({ payload: { mfaResponse }, meta }) {
    var _a;
    const { resolve, reject } = meta;
    // TODO: If user submits an MFA response but we are no longer polling, perhaps we should just fail...
    const requestUrl = `${(_a = (0, core_1.getEnvironmentConfig)()) === null || _a === void 0 ? void 0 : _a.services_url}/${mfaResponse.submitUrl}`;
    const requestBody = {
        institutionLoginId: mfaResponse.institutionLoginId,
        mfaResponses: mfaResponse.answers.map((answer) => ({
            key: answer.id,
            response: answer.value,
        })),
    };
    try {
        yield (0, effects_1.call)(qcsAxios.post, requestUrl, requestBody);
        yield (0, effects_1.put)(actions.refreshAccountsMfaFormSubmitResponse({ institutionLoginId: mfaResponse.institutionLoginId }, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
        yield (0, effects_1.call)(resolve, mfaResponse.institutionLoginId);
    }
    catch (error) {
        log.log('Received error while submitting MFA', mfaResponse.institutionLoginId, error);
        const errorResponse = new types_1.RefreshAccountsMfaFormSubmitError(error, mfaResponse.institutionLoginId);
        yield (0, effects_1.put)(actions.refreshAccountsMfaFormSubmitResponse(errorResponse, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
        yield (0, effects_1.call)(reject, errorResponse);
    }
}
exports.submitMfaResponse = submitMfaResponse;
function* refreshAccountsMfaFormSubmitActionWatcher() {
    yield (0, effects_1.takeEvery)(actions.refreshAccountsMfaFormSubmit, submitMfaResponse);
}
exports.refreshAccountsMfaFormSubmitActionWatcher = refreshAccountsMfaFormSubmitActionWatcher;
exports.default = [
    getInstitutionLoginsActionWatcher,
    updateInstitutionLoginActionWatcher,
    deleteInstitutionLoginActionWatcher,
    deleteInstitutionLoginSuccessActionWatcher,
    getInstitutionLoginSuccessActionWatcher,
    qcsInstitutionLoginActionActionWatcher,
    refreshAccountsWatcher,
    refreshAccountsMfaFormSubmitActionWatcher,
];
